import { z } from 'zod';

const EnvConfigSchema = z.object({
  productName: z
    .string({
      description: `This is the name of your product. Ex. "Offsite"`,
      required_error: `Please provide the variable NEXT_PUBLIC_PRODUCT_NAME`,
    })
    .min(1),
});

const EnvConfig = EnvConfigSchema.parse({
  productName: process.env.NEXT_PUBLIC_PRODUCT_NAME,
});

export default EnvConfig;
